import React, { useEffect } from 'react';
import { Container } from 'react-bootstrap';

import { Props } from './types';
import LoadingOverlay from '../LoadingOverlay/LoadingOverlay';

export const PageContent: React.FunctionComponent<Props> = (props) => {
    useEffect(() => {
        if (props.title) {
            document.title = `Ontoworks | ${props.title}`;
        }
    }, [props.title]);

    return (
        <div className="content d-flex flex-column flex-column-fluid" id="page-content-wrapper">
            <Container fluid>
                <LoadingOverlay isLoading={props.isLoading}>{props.children}</LoadingOverlay>
            </Container>
        </div>
    );
};

PageContent.displayName = 'PageContent';
